import { MachineAttributeSrv } from '@/api/askToBuy/askToBuy'
import{ brandListSrv, carouselSrv } from '../../api/home/home'
const state = {
  data: [],
  brandList: [],
  checkBox: {},
  carouselList: []
};

const mutations = {
  setState(state, data,type) {
    state.checkBox = data;
  },
  setBrandList(state,data,type) {
    if(data){
      state.brandList = data;
    }
  },
  setCarouselList( state,data) {
    state.carouselList = data
  }
};

const actions = {
  getDataAction({ commit }, param) {
    setTimeout(() => {
      // commit('setState', param)
    })
  },
  getMachineAttributeAction({ commit },params){
    MachineAttributeSrv(params).then( res => {
      // console.log(res,'求购页面多选框的设备')
      commit('setState',res.data)
    })
  },
  getBrandListAction({ commit },params){
    brandListSrv(params).then( res => {
      commit('setBrandList',res.data.dataList)
    })
  },
  getCarouselAction({ commit },params){
    carouselSrv(params).then( res => {
      // console.log(res,'轮播图')
      commit('setCarouselList',res.data.dataList)
    })
  }
};

const getters = {
  getData(state,type) {
    // console.log(type)
    return state
  },
  getBrandList(state){
    return state.brandList;
  },
  getAttrData(state){
    return state.checkBox
  },
  getCarouselList( state ){
    let arr = []
    state.carouselList.map( i => {
      let obj = {}
      obj.imgSrc = i.filePath
      obj.imgLink = i.adUrl
      arr.push(obj)
    })
    return arr
  }
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}



// WEBPACK FOOTER //
// ./src/store/modules/home.js